"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCompressOpts = exports.defaultExpandOpts = exports.experimentalTreeDataSupport = exports.isCompact = exports.isNullish = exports.instanceOfContentBlock = exports.instanceOfEditorState = exports.instanceOfContentState = void 0;

var _draftJs = require("draft-js");

var _isPlainObject = _interopRequireDefault(require("is-plain-object"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var instanceOfContentState = function instanceOfContentState(maybeContentState) {
  var _maybeContentState$co;

  return (maybeContentState === null || maybeContentState === void 0 ? void 0 : (_maybeContentState$co = maybeContentState.constructor) === null || _maybeContentState$co === void 0 ? void 0 : _maybeContentState$co.name) === 'ContentState';
};

exports.instanceOfContentState = instanceOfContentState;

var instanceOfEditorState = function instanceOfEditorState(maybeEditorState) {
  var _maybeEditorState$con;

  return (maybeEditorState === null || maybeEditorState === void 0 ? void 0 : (_maybeEditorState$con = maybeEditorState.constructor) === null || _maybeEditorState$con === void 0 ? void 0 : _maybeEditorState$con.name) === 'EditorState';
};

exports.instanceOfEditorState = instanceOfEditorState;

var instanceOfContentBlock = function instanceOfContentBlock(maybeContentBlock) {
  var _maybeContentBlock$co;

  return (maybeContentBlock === null || maybeContentBlock === void 0 ? void 0 : (_maybeContentBlock$co = maybeContentBlock.constructor) === null || _maybeContentBlock$co === void 0 ? void 0 : _maybeContentBlock$co.name) === 'ContentBlock';
};

exports.instanceOfContentBlock = instanceOfContentBlock;

var isNullish = function isNullish(val) {
  return typeof val === 'undefined' || val === null;
};

exports.isNullish = isNullish;

var isCompact = function isCompact(maybeObject) {
  return (0, _isPlainObject.default)(maybeObject) && Object.keys(maybeObject).length < 7;
};

exports.isCompact = isCompact;
var experimentalTreeDataSupport = (window.__DRAFT_GKX || {}).draft_tree_data_support;
exports.experimentalTreeDataSupport = experimentalTreeDataSupport;
var defaultBlockProperties = {
  data: {},
  depth: 0,
  entityRanges: [],
  inlineStyleRanges: [],
  text: '',
  type: 'unstyled'
};
var blockProperties = experimentalTreeDataSupport ? _objectSpread({}, defaultBlockProperties, {
  children: []
}) : defaultBlockProperties;
var defaultExpandOpts = {
  createBlock: function createBlock(block) {
    return _objectSpread({
      key: (0, _draftJs.genKey)()
    }, blockProperties, block);
  }
};
exports.defaultExpandOpts = defaultExpandOpts;
var defaultCompressOpts = {
  discardKeys: false,
  convertToRaw: _draftJs.convertToRaw
};
exports.defaultCompressOpts = defaultCompressOpts;